import { getCookie } from 'cookies-next';
import { GetServerSidePropsContext } from 'next';
import Head from 'src/general/components/Head/Head';
import { useTranslation } from 'src/lib/translations';
import {
  PrivacyContent,
  PrivacyContentProps,
} from 'src/modules/PrivacyPageContent';
import { getStaticPrivacyPolicyContent } from 'src/modules/PrivacyPageContent/staticContent';

interface PrivacyPageProps {
  content: PrivacyContentProps;
}

const Privacy = ({ content }: PrivacyPageProps) => {
  const { t } = useTranslation();
  const { sections, title } = content;

  return (
    <>
      <Head
        description={t('Head.PrivacyPage.Description')}
        subtitle={t('Head.PrivacyPage.Subtitle')}
        title={t('Head.PrivacyPage.Title')}
      />
      <PrivacyContent sections={sections} title={title} />
    </>
  );
};

export async function getServerSideProps({
  req,
  res,
}: GetServerSidePropsContext) {
  const locale = (getCookie('language', { req, res }) as string) || 'en-US';
  const content = getStaticPrivacyPolicyContent(locale);

  return {
    props: {
      content,
      locale,
    },
  };
}

export default Privacy;
